import { render } from "./BashTheLimitScreen.vue?vue&type=template&id=5460a146&scoped=true&ts=true&lang=pug"
import script from "./BashTheLimitScreen.vue?vue&type=script&lang=ts"
export * from "./BashTheLimitScreen.vue?vue&type=script&lang=ts"

import "./BashTheLimitScreen.vue?vue&type=style&index=0&id=5460a146&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5460a146"]])

export default __exports__